import { List, ListItemText, Paper } from "@mui/material";
import { ListItemButton, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import Timeoff from "../../models/Timeoff";
import TimeOffUtils from "../../utils/TimeOffUtils";
import { useEffect, useState } from "react";
import TimeoffViewDialog from "../TimeOffViewDialog";
import OpsStringUtils from "../../utils/OpsStringUtils";
import { TimeOffType } from "../../types/TimeOffType";
import OpsDateUtils from "../../utils/OpsDateUtils";
import OpsPanel from "../OpsPanel";
import icon from "../../img/icons/work_logs.svg"

interface Props {
  /**
   * Data to be rendered
   */
  rows: Timeoff[];
}

export default function UpcomingTimeoffsTile({ rows }: Props) {
  const history = useHistory();

  const [viewTimeoff, setViewTimeoff] = useState<Timeoff | undefined>();

  useEffect(() => {}, [rows]);

  const closeViewDialog = () => {
    setViewTimeoff(undefined);
  };

  return rows.length > 0 ? (
    <>
      <OpsPanel
      title="Upcoming Timeoffs"
      actionsRequired={false}
      icon={icon}
      >
        <Paper elevation={0} style={{ minHeight: "15.5em", maxHeight: "15.5em", overflow: "auto" }}>
          <List disablePadding>
            {rows.map((row, index) => (
            <ListItemButton alignItems="flex-start" disableGutters dense>
              <ListItemText
                primary={row.requesterProjectName!.concat(" - ", row.requester.firstName, " ", row.requester.lastName)}
                secondary={
                  row.type === TimeOffType.BIRTHDAY
                    ? OpsStringUtils.capitalize(row.type).concat(
                        ": ",
                        OpsDateUtils.formatInUTCAsDDDMMM(new Date(row.shortStartDate))
                      )
                    : TimeOffUtils.getTimeoffDetails(row) + " -" + OpsStringUtils.capitalize(row.status)
                }
                onClick={row.type === TimeOffType.BIRTHDAY ? () => null : () => setViewTimeoff(row)}
                primaryTypographyProps={{ fontWeight: "bold" }}
              />
            </ListItemButton>
              ))}
              </List>
            </Paper>
      </OpsPanel>    
      {viewTimeoff && <TimeoffViewDialog viewTimeoff={viewTimeoff} selectedFiles={viewTimeoff!.documentation} onClose={closeViewDialog} />}
    </>
  ) : null;
}
